import { ArrowLeft, Cookie, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./LegalPages.css";
import { Helmet } from "react-helmet-async";

export function Cookies() {
  const { t } = useTranslation();

  return (
    <>
     <Helmet>
      <title>{t("seo.cookies.title")}</title>

      <meta
        name="description"
        content={t("seo.cookies.description")}
      />

      <link
        rel="canonical"
        href="https://francescotransfers.com/cookies"
      />
    </Helmet>
    <main className="legal-page">
      <div className="legal-page-container">
        <Link to="/" className="legal-back-link">
          <ArrowLeft size={18} />
          <span>{t("cookies.back")}</span>
        </Link>

        <header className="legal-header">
          <div className="legal-icon">
            <Cookie size={30} />
          </div>

          <div>
            <span className="legal-eyebrow">
              {t("cookies.eyebrow")}
            </span>

            <h1>{t("cookies.title")}</h1>

            <p>{t("cookies.intro")}</p>
          </div>
        </header>

        <div className="legal-content">
          <section className="legal-section">
            <h2>{t("cookies.what.title")}</h2>
            <p>{t("cookies.what.description")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("cookies.usage.title")}</h2>
            <p>{t("cookies.usage.description")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("cookies.thirdParty.title")}</h2>
            <p>{t("cookies.thirdParty.description")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("cookies.control.title")}</h2>
            <p>{t("cookies.control.description")}</p>
          </section>

          <aside className="legal-notice">
            <ShieldCheck size={22} />

            <div>
              <strong>{t("cookies.notice.title")}</strong>
              <p>{t("cookies.notice.description")}</p>
            </div>
          </aside>

          <p className="legal-updated">
            {t("cookies.lastUpdated")}
          </p>
        </div>
      </div>
    </main>
    </>
  );
}